import { render } from "./PsLabelTitle3.vue?vue&type=template&id=fe05bb62&ts=true"
import script from "./PsLabelTitle3.vue?vue&type=script&lang=ts"
export * from "./PsLabelTitle3.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__